import script from "./ViewGeneratePVWithWarrantTempPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGeneratePVWithWarrantTempPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewGeneratePVWithWarrantTempPage.vue?vue&type=style&index=0&id=12cd9a92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cd9a92"]])

export default __exports__